import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, Injector, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HttpService } from '@app/@core/services/http.service';
import { SURRENDER_NOTES } from '@app/shared/constants/registration-constants';
import { DataGridComponent } from '@app/shared/custom-component/data-grid/data-grid.component';
import { DataGridVO } from '@app/shared/custom-component/data-grid/data-grid.model';
import { CommonService } from '@app/shared/services/common.service';
import { DropdownModule } from 'primeng/dropdown';
import { EditorModule } from 'primeng/editor';
import { forkJoin, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs';
import { SurrenderService } from '../surrender.service';
import { LocalService } from '@app/@core/services/local.service';
import { DxButtonModule, DxDataGridModule, DxPopupModule, DxTemplateModule } from 'devextreme-angular';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from '@app/@core/services/alert.service';
import { DataStoreService } from '@pics-core/dynamic';
import { ActivatedRoute, Router } from '@angular/router';
import { FingerprintPortalService } from '@app/fingerprint-portal/fingerprint-portal.service';

@Component({
  selector: 'app-surrender-application',
  standalone:true,
  templateUrl: './surrender-application.component.html',
  styleUrls: ['./surrender-application.component.scss'],
  imports:[CommonModule,DropdownModule,ReactiveFormsModule,
    EditorModule, DataGridComponent,
    FormsModule,
    MatTooltipModule,
        DxDataGridModule,
        DxPopupModule,
        DxTemplateModule,
        DxButtonModule,
        DatePipe
  ]
})
export class SurrenderApplicationComponent implements OnInit , OnDestroy{
  @ViewChild('NotesModal') NotesModal!: TemplateRef<any>;
  @ViewChild('RequestSurrender') RequestSurrender!: TemplateRef<any>;
  @ViewChild('CancelSurrender') CancelSurrender! : TemplateRef<any>;
  @ViewChild('showDeleteModal') showDeleteModal! : TemplateRef<any>;
  @ViewChild('showSubmitModal') showSubmitModal! : TemplateRef<any>;
  @ViewChild('showFinalDetermination') showFinalDetermination! : TemplateRef<any>;
  @ViewChild('previewCommunicationModal') previewCommunicationModal! : TemplateRef<any>;
  @ViewChild('actionModal') actionModal! : TemplateRef<any>;
  @ViewChild('editActionModal') editActionModal! : TemplateRef<any>;
  @ViewChild('analystCommunicationEditor') editor: any;
  placeholderMessage : any;
  placeholderMessages : any = [];
  errorMessage : any;
  errorMessages : any = [];
  Provider :boolean = true;
  ApplicationInstruction: boolean = true;
  license : boolean = true;
  Notes : boolean = true;
  acknowledgement : boolean = true;
  destroy = new Subject();
  providerForm : FormGroup;
  applicationForm:FormGroup;
  surrenderNotesForm:FormGroup;
  editSurrenderNotesForm: FormGroup;
  requestSurrenderForm: FormGroup;
  actionSurrender: FormGroup;
  editActionSurrender : FormGroup;
  surrenderNotesSectionList = SURRENDER_NOTES;
  licenseKindHeaders : any = [];
  endorsementHeaders : any = [];
  surrenderNotesHeaders : any = [];
  surrenderEndorsementGrid: DataGridVO = DataGridVO.create({});
  surrenderNotesGridConfig: DataGridVO = DataGridVO.create({});
  surrenderNotesData : any;
  licenseKindData = [];
  endorsementData = [];
  visibleColumnsLicenseKind: { [key: string]: boolean } = {};
  visibleColumnsEndorsement: { [key: string]: boolean } = {};
  visibleSurrenderNotesColumns: { [key: string]: boolean } = {};
  customModal: NgbModalRef;
  isViewNotes: boolean = false;
  isEditNotes: boolean = false;
  selectedNotesRow: any = null;
  deleteSelectedNotesRow: any = null;
  selectedLicenseKind:any;
  selectedEndorseKind:any;
  selectedRequestRow:any;
  licenseKindList : any =[];
  licenseStatusList : any =[];
  endorseList : any =[];
  endorseStatusList : any = [];
  personData : any;
  applicationData:any
  requestType:any;
  signatureError : boolean = false;
  surrenderFlow:any;
  applicationStatus:any;
  applicationId:any;
  toastMessages=[];
  toastMessage = {};
  actionType:any;
  selectedActionRow:any;
  isEditActionNotes : boolean = false;
  isViewActionNotes : boolean = false;
  providerList:any =[];
  dataStore: DataStoreService;
  submitionConfirmed : boolean = false;
  applicationStatusList:any;
  viewOnly:boolean = false;
  disableNote:boolean = true;
  surrenderRequestedFlag:boolean = false;
  todayDate: string = new Date().toISOString().split('T')[0];
  inputApplicationData:any;
  filteredEndorsementData = [];
  pendingHtml : any;
  currentEditorLength = 0;
  quillInstance: any;

  constructor(
    private readonly fb: FormBuilder,
    private commonService : CommonService,
    private sessionStorage : LocalService,
    private httpService : HttpService,
    private surrenderService : SurrenderService,
    private modalService: NgbModal,
    private readonly alertService: AlertService,
    injector: Injector,
    private route: ActivatedRoute,
    private router: Router,
    private fingerprintService: FingerprintPortalService,
    private cd: ChangeDetectorRef,
    
  ){
    this.dataStore = injector.get<DataStoreService>(DataStoreService);
  }

  ngOnInit(): void {
    this.loadDropdownDataMessages();
    const surrenderMode = this.sessionStorage.getItem('surrenderMode');
    this.inputApplicationData = this.sessionStorage.getObj('navigationData');
    this.viewOnly = (surrenderMode === 'view') ? true : false;
    const newApplicationFlag = this.sessionStorage.getItem('newSurrenderApplication') === 'true' ? true : false;
    this.surrenderFlow =this.sessionStorage.getItem('surrender');
    this.applicationStatus = this.sessionStorage.getItem('applicationStatus');
    this.applicationId = this.sessionStorage.getItem('applicationID');
    setTimeout(() => {
      if(newApplicationFlag == true){
        this.fetchSurrenderData();
      }else{
        this.getSurrenderApplicationData();
      }
    }, 500);
    this.providerForm = this.fb.group({
      arlProvider : []
    });
    this.applicationForm = this.fb.group({
      acknowledgementSign :[null, Validators.required]
    })
    this.surrenderNotesForm = this.fb.group({
      surrenderNotesSection : [this.surrenderNotesSectionList[0], Validators.required],
      surrenderNotesTextData : [null, [Validators.required,Validators.maxLength(4000)]]
    });
    this.editSurrenderNotesForm = this.fb.group({
      editNotesSection : [this.surrenderNotesSectionList[0], Validators.required],
      editNotesTextData : [null, [Validators.required,Validators.maxLength(4000)]]
    });
    this.requestSurrenderForm = this.fb.group({
      licenseSurrenderNotes : [null,[Validators.maxLength(4000)]],
      endoSurrenderNotes : [null, [Validators.maxLength(4000)]]
    });
    this.actionSurrender = this.fb.group({
      actionSurrenderNotes : [''],
    });
    this.editActionSurrender = this.fb.group({
      editActionSurrenderNotes : [null,[Validators.maxLength(4000)]],
    });
    this.commonService.getMetaData('surrender-headers').pipe(take(1),takeUntil(this.destroy))
    .subscribe({
      next:(headers:any)=>{
        this.endorsementHeaders = headers.surrenderEndorsement.map(header => ({
            ...header,
            label: header.caption,
            caption: header.caption,
            allowSearch: header.allowSearch || { isSearchEnable: false, type: 'string' }
          }));
        this.endorsementHeaders.forEach(header =>{
          this.visibleColumnsEndorsement[header.dataField] = true;
          if(this.applicationStatus !== 'Analyst Pending' && this.applicationStatus !== 'In Progress,Not Submitted'){
            this.visibleColumnsEndorsement['action_notes'] = true;
          }else{
            this.visibleColumnsEndorsement['action_notes'] = false;
          }
        });
        this.surrenderNotesHeaders = headers.surrendNotes.map(header => ({
            ...header,
            label: header.caption,
            caption: header.caption,
            allowSearch: header.allowSearch || { isSearchEnable: false, type: 'string' }
          }));
        this.surrenderNotesHeaders.forEach(header =>{
          this.visibleSurrenderNotesColumns[header.dataField] = true;
        })
        this.loadData();
        this.setNotesData();
        this.applyViewOnly();
      }
    })
    this.surrenderNotesForm.get('surrenderNotesSection').disable();
  }
  
  fetchSurrenderData(){
    this.licenseKindData = [];
    this.endorsementData = [];
    const payload ={
      userId : Number(this.sessionStorage.getItem('userIdForFetch')),
    }
    let license_row = 0;
    let endorse_row = 0;
    this.surrenderService.fetchSurrender(payload).pipe(take(1),takeUntil(this.destroy))
    .subscribe({
      next:(res:any)=>{
        if(res?.data?.success){
          const data = res?.data?.data;
          data?.p_license_dtls.forEach(license => {
            const p_license_provisions =[];
            const p_license_endorsements = [];
            if(license.license_kind != null){
              license.licenses.forEach(response =>{
                  (response.provisions != null && !p_license_provisions.includes(response.provisions)) ? p_license_provisions.push(response.provisions): null;
                  (response.endorsements != null && !p_license_endorsements.includes(response.endorsements)) ? p_license_endorsements.push(response.endorsements): null;
              })
              const licenseData = {
                license_row_number : license_row++,
                license_kind : license.license_kind,
                provisions: p_license_provisions.length>0 ? p_license_provisions : '-',
                endorsements :p_license_endorsements.length >0 ? p_license_endorsements : '-',
                request_notes : license.license_req_note? license.license_req_note: '-',
                cd_lk_status: license.cd_lk_status ? license.cd_lk_status: null,
                decisionFlag : null,
                action_notes : license.license_analyst_req_note ? license.license_analyst_req_note : null,
                status : null,
              }
              this.licenseKindData.push(licenseData);
            }
          })
          data?.p_endorsement_dtls.forEach(endo => {
            const p_endo_provisions =[];
            if(endo.endorsement != null){
              endo.licenses.forEach(response =>{
                response.provisions != null ? p_endo_provisions.push(response.provisions): null;
              })
              const endoData = {
                endorse_row_number : endorse_row++,
                license_kind : endo.license_kinds ,
                provisions:  p_endo_provisions.length>0 ? p_endo_provisions : '-',
                endorsements :endo.endorsement,
                request_notes: endo.endorse_req_note ? endo.endorse_req_note :'-',
                cd_endo_status : endo.cd_endo_status ? endo.cd_endo_status : null,
                decisionFlag : null,
                action_notes : endo.endorse_analyst_req_note ? endo.endorse_analyst_req_note.replace(/<p><br><\/p>\s*$/, '') : null,
                status : null,
              }
              this.endorsementData.push(endoData);
            }
          })
          this.personData = data.p_profile[0];
          this.applicationData = data.p_application[0] ?  data.p_application[0] : null;
          if(this.applicationData &&  this.applicationData?.application_type == 'ARL (Alternative Route to Licensure)' || this.applicationData?.application_type == 'Substitute + ARL'){
            this.providerForm.get('arlProvider').patchValue(data.p_application[0].arlprovider);
          }
          
          this.providerForm.disable();
          this.loadData();
        }
      }
    })
   
  }
  getSurrenderApplicationData(){
    this.licenseKindData = [];
    this.endorsementData = [];
    const payload ={
      userId : Number(this.sessionStorage.getItem('userIdForFetch')),
      applicationId : Number(this.applicationId)
    }
    let license_row = 0;
    let endorse_row = 0;
    this.surrenderService.getSurrenderApplicationData(payload).pipe(take(1),takeUntil(this.destroy))
    .subscribe({
      next:(res:any)=>{
        if(res?.data?.success){
          const data = res?.data?.data;
          data?.p_license_dtls.forEach(license => {
            const p_license_provisions =[];
            const p_license_endorsements = [];
            if(license.license_kind != null){
              license.licenses.forEach(response =>{
                  (response.provisions != null && !p_license_provisions.includes(response.provisions)) ? p_license_provisions.push(response.provisions): null;
                  (response.endorsements != null && !p_license_endorsements.includes(response.endorsements)) ? p_license_endorsements.push(response.endorsements): null;
              })
              const licenseData = {
                license_row_number : license_row++,
                license_kind : license.license_kind,
                provisions: p_license_provisions.length>0 ? p_license_provisions : '-',
                endorsements :p_license_endorsements.length >0 ? p_license_endorsements : '-',
                request_notes : license.license_req_note? license.license_req_note: '-',
                cd_lk_status: license.cd_lk_status ? license.cd_lk_status: null,
                decisionFlag : license.license_analyst_flag != null ? license.license_analyst_flag : null,
                action_notes : license.license_analyst_req_note ? license.license_analyst_req_note : null,
                status : null,
              }
              this.licenseKindData.push(licenseData);
            }
          })
          data?.p_endorsement_dtls.forEach(endo => {
            const p_endo_provisions =[];
            if(endo.endorsement != null){
              endo.licenses.forEach(response =>{
                response.provisions != null ? p_endo_provisions.push(response.provisions): null;
              })
              const endoData = {
                endorse_row_number : endorse_row++,
                license_kind : endo.license_kinds ,
                provisions:  p_endo_provisions.length>0 ? p_endo_provisions : '-',
                endorsements :endo.endorsement,
                request_notes: endo.endorse_req_note ? endo.endorse_req_note :'-',
                cd_endo_status : endo.cd_endo_status ? endo.cd_endo_status : null,
                decisionFlag : endo.endorse_analyst_flag != null ? endo.endorse_analyst_flag : null,
                action_notes : endo.endorse_analyst_req_note ? (endo.endorse_analyst_req_note).replace(/<p><br><\/p>\s*$/, '') : null,
                status : null,
              }
              this.endorsementData.push(endoData);
            }
          })
          this.personData = data.p_profile[0];
          this.applicationData = data.p_application[0] ?  data.p_application[0] : null;
          if(this.applicationData &&  this.applicationData?.application_type == 'ARL (Alternative Route to Licensure)' || this.applicationData?.application_type == 'Substitute + ARL'){
            this.providerForm.get('arlProvider').patchValue(data.p_application[0].arlprovider);
          }
          if(this.applicationStatus !== 'In Progress,Not Submitted'){
           this.applicationForm.get('acknowledgementSign').patchValue(this.personData.person_name);
           this.applicationForm.get('acknowledgementSign')?.disable();
           this.submitionConfirmed = true;
          }
          this.providerForm.disable();
          this.loadData();
        }
      }
    })
    const payload1 ={
       application_id : this.applicationId,
    }
    this.surrenderService.selectSurrenderNotes(payload1).pipe(take(1),takeUntil(this.destroy))
    .subscribe({
      next:((res:any)=>{
        this.surrenderNotesData = res.data;
        this.setNotesData();
      })
    })
  }
  getUserId(): string | null {
    let userObj = this.commonService.getCurrentUserData();

    if (!userObj) {
      const userFromSession = this.sessionStorage.getItem('user');
      if (userFromSession) {
        userObj = JSON.parse(userFromSession);
      }
    }

    if (!userObj) {
      return null;
    }

    return userObj?.id || userObj?.user_id || userObj?.userId || null;
  }
  private getUserFullName(): string {
    const userObj = this.commonService.getCurrentUserData() ||
      JSON.parse(this.sessionStorage.getItem('user') || '{}');
    if (userObj?.firstname && userObj?.lastname) {
      return `${userObj.firstname} ${userObj.lastname}`;
    }
    return '';
  }
   private async loadDropdownDataMessages() {
      forkJoin([
        this.httpService.get('/domain/lookup?requestType=PLACEHOLDER MESSAGES'),
        this.httpService.get('/domain/lookup?requestType=MESSAGES'),
        this.httpService.get('/domain/lookup?requestType=LICENSE KIND'),
        this.httpService.get('/domain/lookup?requestType=LICENSE STATUS'),
        this.httpService.get('/domain/lookup?requestType=ENDORSE_STATUS'),
        this.httpService.get('/domain/lookup?requestType=ENDORSEMENT'),
        this.httpService.get('/domain/lookup?requestType=TOAST MESSAGES'),
        this.httpService.get('/domain/newlookup?requestType=ARL PROVIDER'),
        this.httpService.get('/domain/lookup?requestType=APPLICATION_STATUS')
      ]).subscribe({
        next: (item: any) => {
          this.placeholderMessages = item[0].data;
          this.errorMessages = item[1].data;
          this.licenseKindList = item[2].data;
          this.licenseStatusList = item[3].data;
          this.endorseList = item[5].data;
          this.endorseStatusList = item[4].data;
          this.toastMessages = item[6].data;
          this.providerList = item[7].data;
          this.applicationStatusList = item[8].data;
          this.placeholderMessage = {};
          this.placeholderMessages.forEach(message => {
            if (message.key && message.value !== undefined) {
              this.placeholderMessage[message.key] = message.value;
            }
          });
        this.toastMessage = {};
        this.toastMessages.forEach(message => {
          if (message.key && message.value !== undefined) {
            this.toastMessage[message.key] = message.value;
          }
        });
        this.errorMessage = {};
        this.errorMessages.forEach(message => {
          if (message.key && message.value !== undefined) {
            this.errorMessage[message.key] = message.value;
          }
        });  
        },
        error: error => {
          console.error('Error loading dropdown data:', error);
        }
      });
    }
  loadData(){
    this.surrenderEndorsementGrid = DataGridVO.create({
      customHeaders : this.endorsementHeaders,
      visibleColumns : this.visibleColumnsEndorsement,
      data : this.endorsementData,
      showActionsColumn : (this.applicationStatus !== 'Analyst Pending' && this.applicationStatus !== 'In Progress,Not Submitted') ? false : true,
    })
  }
  //  clearSurrenderNotesSection(){
  //   this.surrenderNotesForm.get('surrenderNotesSection')?.setValue(null);
  // }
  //  clearEditComplaintNotesSection(){
  //   this.editSurrenderNotesForm.get('editNotesSection')?.setValue(null);
  // }
  notesModal(row: any, isEdit: boolean, isView: boolean){
    this.selectedNotesRow = row;
    this.isEditNotes = isEdit;
    this.isViewNotes = isView;
    
    // this.editSurrenderNotesForm.get('editNotesSection')?.setValue(row.section_code);
    this.editSurrenderNotesForm.get('editNotesTextData')?.setValue(row.note_text);
    if (isView) {
      this.editSurrenderNotesForm.disable();
    } else {
      this.editSurrenderNotesForm.get('editNotesSection').disable();
      this.editSurrenderNotesForm.get('editNotesTextData').enable();
    }
    this.customModal = this.modalService.open(this.NotesModal, {
      backdrop: "static",
      centered: true,
      size: "xl",
      windowClass: 'custom-edit-record-modal'
    });
  }

   resetEditModal(){
    //  this.editSurrenderNotesForm.get('editNotesSection')?.setValue(this.selectedNotesRow.note_section);
    this.editSurrenderNotesForm.get('editNotesTextData')?.setValue(this.selectedNotesRow.note_text);
  }
  updateNotesData(){
    const noteCtrl = this.editSurrenderNotesForm.get('editNotesTextData');
    const rawValue = noteCtrl?.value;
    const trimmedValue = typeof rawValue === 'string' ? rawValue.trim() : rawValue;

    // Keep the FormControl in sync with what the user actually sees before validating.
    if (rawValue !== trimmedValue) {
      noteCtrl?.setValue(trimmedValue);
    }

    if (this.editSurrenderNotesForm.invalid || !trimmedValue) {
      this.editSurrenderNotesForm.markAllAsTouched();
      noteCtrl?.markAsTouched();
      noteCtrl?.updateValueAndValidity();
      return;
    }
    const payload ={
       application_id: this.selectedNotesRow.application_id,
       strNoteText: trimmedValue,
       strNoteSection: this.editSurrenderNotesForm.get('editNotesSection')?.value,
        intUpdatedBy: this.getUserId(),
        note_id: this.selectedNotesRow.note_id

    };
    this.surrenderService.updateSurrenderNotes(payload).pipe(take(1),takeUntil(this.destroy)).subscribe({
      next: (response) => {
        this.surrenderNotesData = response.data;
        this.selectedNotesRow = null;
        this.setNotesData();
        this.customModal.close();
        this.alertService.success(this.toastMessage['T0020']);
      },
      error: (error) => {
        console.error('Error updating surrender notes:', error);
      }
    });
  }
  closeViewNotesModal(){
    this.customModal.close();
  }
   setNotesData(){
     this.surrenderNotesGridConfig = DataGridVO.create({
      customHeaders: this.surrenderNotesHeaders,
      visibleColumns: this.visibleSurrenderNotesColumns,
      data: this.surrenderNotesData
    });
  }
   resetNotesData(){
    this.surrenderNotesForm.reset();
  }
  requestLicenseSurrender(selectedRow,type){
    this.requestType = type;
    this.requestSurrenderForm.reset();
    if(this.requestType == "licenseRequest"){
      this.requestSurrenderForm.get('licenseSurrenderNotes').setValidators([Validators.maxLength(4000),Validators.required]);
      this.requestSurrenderForm.get('endoSurrenderNotes').setValidators([Validators.maxLength(4000)]);
    }else if(this.requestType == "endorseRequest"){
      this.requestSurrenderForm.get('licenseSurrenderNotes').setValidators([Validators.maxLength(4000)]);
      this.requestSurrenderForm.get('endoSurrenderNotes').setValidators([Validators.maxLength(4000),Validators.required]);
    }
    this.selectedRequestRow = selectedRow;
    this.selectedLicenseKind = selectedRow.license_kind;
    this.selectedEndorseKind = selectedRow.endorsements;
    this.customModal = this.modalService.open(this.RequestSurrender, {
      backdrop: "static",
      centered: true,
      size: "md",
      windowClass: 'custom-edit-record-modal'
    });
  }
  updateLicenseSurrender(){
    this.surrenderRequestedFlag = true;
     const payload = {
      cd_license_kind : this.licenseKindList.find(list => list.value === this.selectedLicenseKind).key,
      cd_license_status : this.licenseStatusList.find(list => list.value === "Surrender Requested").key,
      license_req_note : this.requestSurrenderForm.get('licenseSurrenderNotes').value,
      application_id : this.applicationId,
    }
    this.surrenderService.updateLicenseRequestSurrender(payload).pipe(take(1),takeUntil(this.destroy))
    .subscribe({
      next:(res:any)=>{
        if(res?.data.success){
          this.getSurrenderApplicationData();
          this.customModal.close();
          this.alertService.success(this.toastMessage['T0058']);
        }
      }
    })
  }
  updateEndorseSurrender(){
    this.surrenderRequestedFlag = true;
    const payload = {
      cd_endorsement : this.endorseList.find(list => list.value === this.selectedEndorseKind).key,
      cd_endo_status : this.endorseStatusList.find(list => list.value === "Surrender Requested").key,
      endorse_req_note : this.requestSurrenderForm.get('endoSurrenderNotes').value,
      application_id : this.applicationId,
    }
    this.surrenderService.updateEndorseSurrender(payload).pipe(take(1),takeUntil(this.destroy))
    .subscribe({
      next:(res:any)=>{
        if(res?.data.success){
          this.getSurrenderApplicationData();
          this.customModal.close();
          this.alertService.success(this.toastMessage['T0058']);
        }
      }
    })
  }
  cancelSurrender(selectedRow,type){
    this.requestType = type;
    this.requestSurrenderForm.get('endoSurrenderNotes').setValidators([Validators.maxLength(4000)]);
    this.requestSurrenderForm.get('licenseSurrenderNotes').setValidators([Validators.maxLength(4000)]);
    this.selectedRequestRow = selectedRow;
    this.selectedLicenseKind = selectedRow.license_kind;
    this.selectedEndorseKind = selectedRow.endorsements;
    this.customModal = this.modalService.open(this.CancelSurrender, {
      backdrop: "static",
      centered: true,
      size: "md",
      windowClass: 'custom-edit-record-modal'
    });
  }
  updateCancelLicenseSurrender(){
     const payload = {
      cd_license_kind : this.licenseKindList.find(list => list.value === this.selectedLicenseKind).key,
      cd_license_status : this.licenseStatusList.find(list => list.value === "Active").key,
      license_req_note : null,
      application_id : this.applicationId,
    }
    this.surrenderService.updateLicenseRequestSurrender(payload).pipe(take(1),takeUntil(this.destroy))
    .subscribe({
      next:(res:any)=>{
        if(res?.data.success){
          this.customModal.close();
          this.getSurrenderApplicationData();
          this.alertService.success(this.toastMessage['T0059']);
        }
      }
  })
  }
  updateCancelEndorseSurrender(){
    const payload = {
      cd_endorsement : this.endorseList.find(list => list.value === this.selectedEndorseKind).key,
      cd_endo_status : this.endorseStatusList.find(list => list.value === "Active").key,
      endorse_req_note : null,
      application_id : this.applicationId,
    }
    this.surrenderService.updateEndorseSurrender(payload).pipe(take(1),takeUntil(this.destroy))
    .subscribe({
      next:(res:any)=>{
        if(res?.data.success){
          this.customModal.close();
          this.getSurrenderApplicationData();
          this.alertService.success(this.toastMessage['T0059']);
        }
      }
    })
  }
  formatInput(event: Event) {
    const input = event.target as HTMLInputElement;
    input.value = input.value
      .toLowerCase()
      .replace(/\b\w/g, char => char.toUpperCase());
     this.applicationForm.get('acknowledgementSign')?.setValue(input.value, { emitEvent: false });
     this.signatureError = (this.applicationForm.get('acknowledgementSign')?.value !== this.personData.person_name) ? true : false;
  }
  get notesFormTouched(): boolean {
    return this.surrenderNotesForm.dirty || Object.values(this.surrenderNotesForm.controls).some(ctrl => ctrl.dirty);
  }
  addNotesData(){
    const noteCtrl = this.surrenderNotesForm.get('surrenderNotesTextData');
    const rawValue = noteCtrl?.value;
    const trimmedValue = typeof rawValue === 'string' ? rawValue.trim() : rawValue;
    if (rawValue !== trimmedValue) {
      noteCtrl?.setValue(trimmedValue);
    }
    if (this.surrenderNotesForm.invalid || !trimmedValue) {
      this.surrenderNotesForm.markAllAsTouched();
      noteCtrl?.markAsTouched();
      noteCtrl?.updateValueAndValidity();
      return;
    }
    const payload ={
       application_id : this.applicationId,
       strNoteSection: this.surrenderNotesForm.get('surrenderNotesSection')?.value,
       strNoteText: trimmedValue,
       strCreatedBy: this.getUserId(),
    }
    this.surrenderService.insertSurrenderNotes(payload).pipe(take(1),takeUntil(this.destroy)).subscribe({
      next: (response) => {
        this.surrenderNotesForm.get('surrenderNotesTextData')?.reset();
        this.surrenderNotesData = response.data;
        this.setNotesData();
        this.alertService.success(this.toastMessage['T0005']);
      },
      error: (error) => {
        console.error('Error adding complaint notes:', error);
      }
    });
  }
  deleteNotesRow(row:any){
    this.deleteSelectedNotesRow = row;
    this.customModal = this.modalService.open(this.showDeleteModal, {
      backdrop: "static",
      size: "md",
      centered: true
    });
    // this.showDeleteModal = true;
  }
  confirmDeleteRow(){
    const payload ={
      application_id: this.deleteSelectedNotesRow.application_id,
      intUpdatedBy: this.getUserId(),
      note_id: this.deleteSelectedNotesRow.note_id
    };
    this.surrenderService.deleteSurrenderNotes(payload).pipe(take(1),takeUntil(this.destroy)).subscribe({
      next: (response) => {
        this.surrenderNotesData = response.data;
        this.setNotesData();
        this.customModal.close();
        this.alertService.success(this.toastMessage['T0040']);
      },
      error: (error) => {
        console.error('Error deleting complaint notes:', error);
      }
    });
  }
  closeDeleteModal(): void {
    // this.showDeleteModal = false;
    this.closeViewNotesModal();
    this.deleteSelectedNotesRow = null;
  }
  submitApplication(){
    this.customModal = this.modalService.open(this.showSubmitModal, {
      backdrop: "static",
      centered: true,
      size: "md",
      windowClass: 'custom-edit-record-modal'
    });
  }
  confirmSubmit(){
    const requestLicenseData = this.licenseKindData.map(license =>{
      return {
        ...license,
        cd_license_kind : this.licenseKindList.find(list => list.value === license.license_kind)?.key,
        cd_lk_status : this.licenseStatusList.find(list => list.value === license.cd_lk_status)?.key
      }
    })
     const requestEndorsementData = this.endorsementData.map(endorse =>{
      return {
        ...endorse,
        cd_endorsement : this.endorseList.find(list => list.value === endorse.endorsements)?.key,
        cd_endo_status : this.endorseStatusList.find(list => list.value === endorse.cd_endo_status)?.key
      }
    })
    const payload= {
      signature :this.applicationForm.get('acknowledgementSign').value,
      user_id : this.getUserId(),
      applicationId: this.applicationId,
      person_id : this.personData.person_id,
      requestLicenseData : requestLicenseData,
      requestEndorsementData : requestEndorsementData,
    }
    this.surrenderService.submitApplication(payload).pipe(take(1),takeUntil(this.destroy))
    .subscribe({
      next:(res)=>{
        if(res.data.success == true){
          this.closeViewNotesModal();
          this.submitionConfirmed = true;
          this.sessionStorage.setItem('applicationStatus',res.data.data.applicationStatus);
          this.applicationStatus = this.sessionStorage.getItem('applicationStatus');
          this.sessionStorage.setItem('surrender', '');
          const url = this.sessionStorage.getItem('backToHome');
          this.router.navigate([url]);
        }
      }
    })
  }
  actionLicenseSurrender(selectedRow, type, action){
    this.actionSurrender.reset();
    this.selectedActionRow = selectedRow;
    this.requestType = type;
    this.actionType = action;
    this.selectedLicenseKind = selectedRow.license_kind;
    this.selectedEndorseKind = selectedRow.endorsements;
    if(this.actionType == 'deny'){
      this.actionSurrender.get('actionSurrenderNotes').setValidators([Validators.required]);
    }else if(this.actionType == 'approve'){
      this.actionSurrender.get('actionSurrenderNotes');
    }
    this.customModal = this.modalService.open(this.actionModal ,{
      backdrop: "static",
      centered: true,
      size: "xl",
      windowClass: 'custom-edit-record-modal'
    });
  }
  proceedAction(){
    this.actionType == 'approve' ? this.alertService.success(this.toastMessage['T0060']) : 
     this.alertService.error(this.toastMessage['T0061']);
    if(this.requestType == 'licenseRequest'){
      const payload ={
        cd_license_kind : this.licenseKindList.find(list => list.value === this.selectedActionRow.license_kind).key,
        license_analyst_flag : (this.actionType === 'approve') ? true : false,
        license_analyst_req_note : this.actionSurrender.get('actionSurrenderNotes').value,
        application_id : this.applicationId,
      }
      this.surrenderService.updateSurrenderLicenseFlag(payload).pipe(take(1),takeUntil(this.destroy))
      .subscribe({
        next:(res:any)=>{
          if(res?.data.success){
            this.getSurrenderApplicationData();
            this.closeViewNotesModal();
          }
        }
      })
    }else if(this.requestType == 'endorseRequest'){
      const payload ={
        cd_endorsement : this.endorseList.find(list => list.value === this.selectedActionRow.endorsements).key,
        endorse_analyst_flag : (this.actionType === 'approve') ? true : false,
        endorse_analyst_req_note : this.actionSurrender.get('actionSurrenderNotes').value,
        application_id : this.applicationId,
      }
      this.surrenderService.updateSurrenderEndorseFlag(payload).pipe(take(1),takeUntil(this.destroy))
      .subscribe({
        next:(res:any)=>{
          if(res?.data.success){
            this.getSurrenderApplicationData();
            this.closeViewNotesModal();
          }
        }
      })
    }
    this.loadData();
  }
  surrenderRequested():boolean {
    return (
      this.licenseKindData.some(row =>
        row.cd_lk_status === 'Surrender Requested'
      ) ||
      this.endorsementData.some(row =>
        row.cd_endo_status === 'Surrender Requested'
      )
    );
  }
  finalDetermination(): boolean {
    return (
      // this.licenseKindData.some(row =>
      //   row.cd_lk_status === 'Surrender Requested' &&
      //   row.decisionFlag == null
      // ) ||
      this.endorsementData.some(row =>
        row.cd_endo_status === 'Surrender Requested' &&
        row.decisionFlag == null
      )
    );
  }
  previewCommunication():boolean{
    return(
      this.endorsementData.some(row =>
        row.decisionFlag == false
      )
    );
  }
  finalCommunication():boolean{
    return(
      this.endorsementData.every(row =>
        row.decisionFlag == true
      ) ?? false
    );
  }

  emptyEditorValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const value = control.value || '';
      // const text = value.replace(/<[^>]*>/g, '').trim();
      // return text.length === 0 ? { required: true } : null;
      const div = document.createElement('div');
      div.innerHTML = value;
      const text = (div.textContent || div.innerText || '').replace(/\u00A0/g, ' ').trim();
      return text.length > 0? null : { required: true };
    };
  }
  actionModalPopup(row, isEdit, isView, type) {
    this.selectedActionRow = row;

    let html = row?.action_notes || '';

    if (html.includes('&lt;')) {
      const temp = document.createElement('div');
      temp.innerHTML = html;
      html = temp.textContent || '';
    }

  this.isEditActionNotes = isEdit;
  this.isViewActionNotes = isView;
  this.actionType = row.decisionFlag === true ? 'approve' : 'deny';
  this.requestType = type;
  this.selectedLicenseKind = row.license_kind;
  this.selectedEndorseKind = row.endorsements;

  if (this.actionType === 'deny') {
    this.actionSurrender.get('actionSurrenderNotes')
    ?.setValidators([this.emptyEditorValidator()]);

  } else {
    this.actionSurrender.get('actionSurrenderNotes');
  }

  this.actionSurrender.updateValueAndValidity();

  this.actionSurrender.patchValue({
    actionSurrenderNotes: html
  });

  this.customModal = this.modalService.open(this.actionModal, {
    backdrop: "static",
    centered: true,
    size: "xl",
    windowClass: 'custom-edit-record-modal'
  });
}
  onEditorInit(event: any) {
    this.quillInstance = event.editor;
    this.quillInstance.root.addEventListener('keydown', (e: KeyboardEvent) => {
      const allowedKeys = ['Backspace','Delete','ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Tab'];
      const text = this.quillInstance.getText().replace(/\n$/, '');
      if (text.length >= 4000 && !allowedKeys.includes(e.key)) {
        e.preventDefault();}});
    const quill = event.editor;
    if (!quill) return;
    let html = this.actionSurrender.get('actionSurrenderNotes')?.value || '';
    if (html.includes('&lt;')) {
      const temp = document.createElement('div');
      temp.innerHTML = html;
      html = temp.textContent || '';
    }
    if (!html.includes('<')) {
      html = `<p>${html}</p>`;
    }
    quill.setContents([]);
    quill.clipboard.dangerouslyPasteHTML(0, html);
    quill.update('silent');
    const control = this.actionSurrender.get('actionSurrenderNotes');
    control?.markAsTouched();
  }

  formatQuillContent(content: string): string {
    const div = document.createElement('div');
    div.innerHTML = content;
    div.querySelectorAll('.ql-ui').forEach(el => el.remove());
    const ol = div.querySelector('ol');
    if (ol) {
      let html = '';
      ol.querySelectorAll('li').forEach(li => {
        const listType = li.getAttribute('data-list');
        if (listType === 'bullet') {
          html += `<ul><li>${li.innerHTML}</li></ul>`;
        } else {
          html += `<ol><li>${li.innerHTML}</li></ol>`;
        }
      });
      ol.outerHTML = html;
    }
    return div.innerHTML;
  }
  
  onEditorChange(event: any) {

  const plainText = event.editor.getText().replace(/\n$/, '');

  if (plainText.length > 4000) {

    event.editor.deleteText(
      4000,
      plainText.length - 4000
    );

    return;
  }

  this.currentEditorLength = plainText.length;
}

textMaxLengthValidator(max: number): ValidatorFn {
  return () => {
    return this.currentEditorLength <= max
      ? null
      : { maxlength: true };
  };
}
  

  resetActionEditModal(){
    this.editActionSurrender.get('editActionSurrenderNotes')?.setValue(this.selectedActionRow.action_notes);
  }
  updateActionNotesData(){
    this.selectedActionRow.action_notes = this.editActionSurrender.get('editActionSurrenderNotes').value;
    this.closeViewNotesModal();
    if(this.requestType == 'licenseRequest'){
      this.licenseKindData.forEach(res=> {
        if(res.license_row_number == this.selectedActionRow.license_row_number){
          Object.assign(res, this.selectedActionRow);        }
      })
    }else if(this.requestType == 'endorseRequest'){
      this.endorsementData.forEach(res => {
        if(res.endorse_row_number == this.selectedActionRow.endorse_row_number){
          Object.assign(res, this.selectedActionRow);
        }
      })
    }
  }
  moveToNext(){
    if((this.surrenderFlow == 'createSurrender' && (this.applicationForm?.invalid || this.signatureError || !this.submitionConfirmed))
     || (this.surrenderFlow == 'analystSurrender' && (this.finalDetermination() || !this.submitionConfirmed) && this.applicationStatus == 'Analyst Pending')){
        this.alertService.error(this.toastMessage['T0017']);
    }else{
    const tabList = JSON.parse(this.dataStore.getData('TABCONFIGLIST') || '[]');
    const currentTabIndex = tabList?.findIndex(tab => tab.id == 3751);
    const parentGridPageInfo = this.sessionStorage.getObj('backToGridPage')
      ? this.sessionStorage.getObj('backToGridPage')
      : this.sessionStorage.getObj('parentGridPage')
      ? this.sessionStorage.getObj('parentGridPage')
      : {};
    let nextTab = null;
    let islastTab = null;
    if (currentTabIndex !== -1 && currentTabIndex == tabList.length - 1) {
      islastTab = tabList[currentTabIndex + 1] ? false : true;
    }
    currentTabIndex !== -1 ? (nextTab = tabList[currentTabIndex + 1]) : null;
    let lastTabId = null;
    if (islastTab) {
      lastTabId = tabList[currentTabIndex]?.id;
    }
    const nextTabIndex = currentTabIndex + 1;
    if (islastTab) {
      this.alertService.success(this.toastMessage['T0052']);
      if (parentGridPageInfo.id) {
        this.router.navigate([`/pages/dynamic-search/search/${parentGridPageInfo?.id}`], { relativeTo: this.route });
      } else {
        this.router.navigate([`/pages/${parentGridPageInfo.name}`], { relativeTo: this.route });
      }
    } else if (nextTab && nextTab.id) {
      this.dataStore.setData('FORM_SUBMISSION_SUCCESS', { isRoute: true, nextPage: nextTabIndex, submissionId: null });
      return;
    } else {
      return;
    }
  }
  }
  stripHtml(html: string): string {
    if (!html) return '';
    const temp = document.createElement('div');
    temp.innerHTML = html;
    return (temp.textContent || temp.innerText || '').trim();
  }
  closeApplication(){
    if(this.finalDetermination()){
      this.alertService.error(this.errorMessage['M0211']);
      return;
    }
    if(this.previewCommunication()){
     this.filteredEndorsementData = this.endorsementData.filter(e => e.decisionFlag == false).map(e => ({
        ...e,
        action_notes: (e.action_notes)}));

      this.customModal = this.modalService.open(this.previewCommunicationModal,{
        backdrop: "static",
        centered: true,
        size:"lg",
      })
    }else{
      this.customModal = this.modalService.open(this.showFinalDetermination, {
      backdrop: "static",
      centered: true,
      size: "md",
      windowClass: 'custom-edit-record-modal'
    });
    }
  }
  confirmFinalDetermination(){
    const updatedEndorse = this.endorsementData.map(row =>{
      return {
        ...row,
        request_notes_update : row.request_notes,
        status :  (row.decisionFlag === true) ? this.endorseStatusList.find(list => list.value === "Inactive").key : this.endorseStatusList.find(list => list.value === "Active").key,
        cd_endorsement : this.endorseList.find(list => list.value === row.endorsements).key,
      }
    });
    const allRequests = [
      ...this.endorsementData
    ];
    const decisions = allRequests
        .map(r => r.decisionFlag)
        .filter(d => d !== null);
    const allApproved = decisions.every(d => d === true);
    const allDenied = decisions.every(d => d === false);
    const hasApproved = decisions.some(d => d === true);
    const hasDenied = decisions.some(d => d === false);
    

    const payload ={
      endorseData : updatedEndorse,
      person_id : this.personData.person_id,
      user_id : this.getUserId(),
      cd_application_status : Number(allApproved ? '9' :
                              allDenied ? this.applicationStatusList.find(s => s.value == 'Analyst Denied').key :
                              (hasApproved && hasDenied) ? this.applicationStatusList.find(s => s.value == 'Partially Approved').key : null),
      application_id : Number(this.applicationId),
    }
    this.surrenderService.finalDeterminationSubmition(payload).pipe(take(1),takeUntil(this.destroy))
    .subscribe({
      next:(res =>{
        this.notification();
        this.closeViewNotesModal();
        this.sessionStorage.setItem('surrender', '');
        const url = this.sessionStorage.getItem('backToHome');
        this.router.navigate([url]);
      })
    })
  }
  notification() {
    const notify = (userid: number, roleid: number) => {
      const payload = {
        priority: "High",
        message: `Application Status Update. The status of your ${this.inputApplicationData.bannerheader["Application Type"]} application ${this.inputApplicationData.bannerheader["Application ID"]} has been updated. View the application details in My Applications on your Dashboard.`,
        actionurl: "/pages/surrender-application",
        userid,
        roleid,
        customformid: 1,
        isnew: true,
        isactive: true
      };
      this.fingerprintService.FingerPrintPortalnotifiction(payload)
        .pipe(take(1), takeUntil(this.destroy)).subscribe({
          next: (res: any) => {
            if (!res.data.success) {
              console.error(`Error while sending notification for user ${userid}, role ${roleid}`);
            }
          },
          error: err => {
            console.error(`Error sending notification for user ${userid}, role ${roleid}:`, err);
          }
        });
    };
    notify(Number(this.sessionStorage.getItem('userIdForFetch')), null);
  }
  private applyViewOnly(): void {
    if (!this.viewOnly) return;
    try {
      if (this.applicationForm && typeof this.applicationForm.disable === 'function') this.applicationForm.disable({ emitEvent: false });
      if (this.surrenderNotesForm && typeof this.surrenderNotesForm.disable === 'function') this.surrenderNotesForm.disable({ emitEvent: false });
      if (this.editSurrenderNotesForm && typeof this.editSurrenderNotesForm.disable === 'function') this.editSurrenderNotesForm.disable({ emitEvent: false });
      if (this.requestSurrenderForm && typeof this.requestSurrenderForm.disable === 'function') this.requestSurrenderForm.disable({ emitEvent: false });
      if (this.actionSurrender && typeof this.actionSurrender.disable === 'function') this.actionSurrender.disable({ emitEvent: false });
      if (this.editActionSurrender && typeof this.editActionSurrender.disable === 'function') this.editActionSurrender.disable({ emitEvent: false });
    } catch (e) {
      // ignore
    }
  }

  ngOnDestroy(): void {
    this.destroy.next({});
    this.destroy.complete();
  }
}
